import { render, staticRenderFns } from "./ModalAtualizarDataBaseReajustamento.vue?vue&type=template&id=0604bd54&"
import script from "./ModalAtualizarDataBaseReajustamento.vue?vue&type=script&lang=js&"
export * from "./ModalAtualizarDataBaseReajustamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports